import {
  useCallback,
  useContext, useEffect, useState,
} from 'react';
import { Link } from 'react-router-dom';
import { TemplatesContext } from '../../../contexts/TemplatesContext';
import SystemBlockItem from './BlockItem';
import Template from '../../../models/Template/Template';
import { CategoriesContext } from '../../../contexts/CategoriesContext';
import ModalComponent from '../../../components/ModalComponent';

interface Props {
  title: string
  open: boolean
  range: Array<'system-block' | 'my-block'> // 選択する範囲はシステムブロックとマイブロオクは両方があるからです。
  handleClose: () => void
  handleTemplateSelected: (template: Template) => void
}

const Index = (props: Props) => {
  const {
    title, open, handleClose, handleTemplateSelected, range,
  } = props;
  const [selectedCategoryId, setSelectedCategoryId] = useState('');
  const [selectedTemplate, setSelectedTemplate] = useState<Template | null>(null);
  const {
    getTemplatesFromCategory,
  } = useContext(TemplatesContext);

  const [selectableBlocks, setSelectableBlocks] = useState<Template[]>([]);
  const { categories } = useContext(CategoriesContext);

  const requestForCategories = useCallback((id: string, range: ('system-block' | 'my-block')[]) => {
    let options: {
      page?: number;
      type?: 'system-block' | 'my-block';
    } = {};

    if (range.includes('system-block') && range.includes('my-block')) {
      options = {};
    } else if (range.includes('system-block')) {
      options = {
        type: 'system-block',
      };
    } else if (range.includes('my-block')) {
      options = {
        type: 'my-block',
      };
    }
    getTemplatesFromCategory(id, options).then((data) => {
      setSelectableBlocks(data.data);
    });
  }, [getTemplatesFromCategory]);

  // デフォルトで一番のカテゴリーを選択します。
  useEffect(() => {
    // すでにカテゴリーメニューを選択された状態なら、なにもしません。
    if (selectedCategoryId !== '') {
      return;
    }

    if (categories.length === 0) {
      return;
    }

    const { id } = categories[0];
    setSelectedCategoryId(id);
    requestForCategories(id, range);
  }, [categories, selectedCategoryId, open, range, requestForCategories]);

  useEffect(() => {
    if (open === true) {
      return;
    }
    setSelectedCategoryId('');
    setSelectableBlocks([]);
  }, [open]);

  const handleCategorySelected = useCallback((id: string) => {
    setSelectedCategoryId(id);
    requestForCategories(id, range);
  }, [requestForCategories, range]);

  return (
      <ModalComponent
        size="xl"
        title={title}
        confirmButtonText="選択する"
        onConfirm={() => handleTemplateSelected(selectedTemplate)}
        show={open}
        closeModal={handleClose}
        centered
        scrollable
        animation={false}
        bodyClassName="m-0 p-0"
        contentClassName="fullViewportHeight"
        style={{ maxWidth: '100%' }}
      >
        <div className="tab modalTabs">
          <ul className="nav navTabs" role="tablist" style={{ overflow: 'auto' }}>
            {categories.map((category) => (
                <li key={category.id}>
                  <Link
                    className={category.id === selectedCategoryId ? 'active' : ''}
                    onClick={() => handleCategorySelected(category.id)}
                    to="#"
                    data-bs-toggle="tab"
                    role="tab"
                  >
                    {category.title}
                  </Link>
                </li>
            ))}
          </ul>
          <div className="tab-content tabContent">
            <div id="tabSection_1" className="tab-pane tabPane active">
              <div className="block-list blockselect">
                {selectableBlocks.map((template) => (
                    <SystemBlockItem
                      key={template.id}
                      handleSelect={(template) => setSelectedTemplate(template)}
                      template={template}
                      active={selectedTemplate && (selectedTemplate.id === template.id)}
                    />
                ))}
              </div>
            </div>
          </div>
        </div>
      </ModalComponent>
  );
};

export default Index;
